// W-0829 — Modal Incluir/Editar SubTipo (Formik + Yup). Único campo editável: Descricao.
// PK composta (Codigo, CodAtendimento) é imutável (RN-8) — em edição só Descricao muda.

import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';

const schemaSubTipo = Yup.object().shape({
  descricao: Yup.string().trim().required('SubTipo deve ser informado.'),
});

const ModalFormSubTipo = ({ show, subTipo, tipoSelecionado, onConfirmar, onCancelar }) => {
  const edicao = !!(subTipo && subTipo.codigo != null);
  const initialValues = { descricao: subTipo ? subTipo.descricao || '' : '' };

  return (
    <Modal show={show} onHide={onCancelar} centered>
      <Modal.Header closeButton>
        <Modal.Title>{edicao ? 'Editar SubTipo' : 'Incluir SubTipo'}</Modal.Title>
      </Modal.Header>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={schemaSubTipo}
        onSubmit={(valores) => {
          if (edicao) {
            onConfirmar({
              codigo: subTipo.codigo,
              cod_atendimento: subTipo.cod_atendimento,
              descricao: valores.descricao.trim(),
            });
          } else {
            onConfirmar({
              cod_atendimento: tipoSelecionado ? tipoSelecionado.codigo : null,
              descricao: valores.descricao.trim(),
            });
          }
        }}
      >
        {({ values, errors, touched, handleChange, handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Body>
              {edicao && (
                <Form.Group>
                  <Form.Label className="small mb-1">Código</Form.Label>
                  <Form.Control size="sm" type="text" value={subTipo.codigo} readOnly disabled />
                </Form.Group>
              )}
              <Form.Group>
                <Form.Label className="small mb-1">Descrição</Form.Label>
                <Form.Control
                  size="sm"
                  name="descricao"
                  type="text"
                  value={values.descricao}
                  onChange={handleChange}
                  isInvalid={touched.descricao && !!errors.descricao}
                />
                {touched.descricao && errors.descricao && (
                  <Form.Text className="text-danger">{errors.descricao}</Form.Text>
                )}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={onCancelar}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit">
                Confirmar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalFormSubTipo;
